'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.Error = undefined

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    "\n  font-weight: normal;\n  text-transform: lowercase;\n  &:before { content: '\u2014 '; }\n"
  ],
  [
    "\n  font-weight: normal;\n  text-transform: lowercase;\n  &:before { content: '\u2014 '; }\n"
  ]
)

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _Label = require('./Label')

var _Label2 = _interopRequireDefault(_Label)

var _Flex = require('./Flex')

var _Flex2 = _interopRequireDefault(_Flex)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _Input = require('./Input')

var _Input2 = _interopRequireDefault(_Input)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _objectWithoutProperties(obj, keys) {
  var target = {}
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
    target[i] = obj[i]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Error = (exports.Error = _Text2.default.extend.attrs({
  className: 'error',
  color: 'error',
  f: 1,
  ml: 1,
  my: 0
})(_templateObject))

var Field = function Field(_ref) {
  var type = _ref.type,
    name = _ref.name,
    label = _ref.label,
    placeholder = _ref.placeholder,
    error = _ref.error,
    props = _objectWithoutProperties(_ref, [
      'type',
      'name',
      'label',
      'placeholder',
      'error'
    ])

  var Component =
    {
      select: _Input.InputSelect,
      textarea: _Input.InputTextarea
    }[type] || _Input2.default
  return _react2.default.createElement(
    _Label2.default,
    { className: type, id: name, mb: 2 },
    _react2.default.createElement(
      _Flex2.default,
      { align: 'center', mb: '2px', wrap: true },
      label,
      error && _react2.default.createElement(Error, { children: error })
    ),
    _react2.default.createElement(
      Component,
      _extends({ name: name, type: type, placeholder: placeholder }, props)
    )
  )
}

Field.displayName = 'Field'

Field.propTypes = {
  /** choose alternate field type (like email, textarea, or select) */
  type: _propTypes2.default.oneOf([
    'text',
    'email',
    'password',
    'textarea',
    'select'
  ]),
  name: _propTypes2.default.string.isRequired,
  /** label text */
  label: _propTypes2.default.string.isRequired,
  /** validation message */
  error: _propTypes2.default.string,
  /** placeholder text */
  placeholder: _propTypes2.default.string
}

Field.defaultProps = {
  theme: _theme2.default,
  type: 'text'
}

exports.default = Field



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Field.js
// module id = 71
// module chunks = 35783957827783 114276838955818 214865505688126